import {logExperiment} from '@homeaway/abacus-client-utils';

import {
    hasEmptyDestinationValues,
    hasEmptyDatesValues,
    hasEmptyGuestsValues,
    hasValidDestinationValues,
    hasValidDatesValues,
    hasHPPageType,
    hasSLPPageType
} from './';

const EXPERIMENT_NAMES = [];

function getExperiment(abacusStore, experimentName) {
    return abacusStore.experimentData[experimentName];
}

/* istanbul ignore next */
function hasAllowableFullExposureExperiment() {
    return true;
}

function hasRunnableAnyVariantExperiment(experiment) {
    return experiment.value > 0;
}

function hasValidExperiment(experiment) {
    return !!experiment && !experiment.exception;
}

function hasAvailableExperiment(abacusStore, experimentName) {
    const experiment = getExperiment(abacusStore, experimentName);

    return hasValidExperiment(experiment);
}

function runExperiment(abacusStore, experimentName, {
    hasAllowableExperiment, // = hasAllowableFullExposureExperiment
    hasRunnableExperiment = hasRunnableAnyVariantExperiment
}) {
    const experiment = getExperiment(abacusStore, experimentName);

    if (hasValidExperiment(experiment) && hasAllowableExperiment(experiment)) {
        logExperiment(experiment);

        return hasRunnableExperiment(experiment);
    }

    return false;
}

function runHPPrePopulateCookieExperiment(abacusStore, systemOptions, searchCookies) {
    return runExperiment(abacusStore, 'HA_HP_SEARCHFORM_PRE_POPULATE_COOKIE', {
        hasAllowableExperiment() {
            const {
                destinationValues,
                datesValues,
                guestsValues
            } = searchCookies;

            return (
                hasHPPageType(systemOptions) && (
                    !hasEmptyDestinationValues(destinationValues) ||
                    !hasEmptyDatesValues(datesValues) ||
                    !hasEmptyGuestsValues(guestsValues)
                )
            );
        }
    });
}

function isHPDestinationEmptySearchErrorExperimentAvailable(abacusStore, systemOptions, latestDestinationValues) {
    return (
        hasHPPageType(systemOptions) && (
            hasAvailableExperiment(abacusStore, 'HA_PTA_LANDING_DestinationlessError') &&
            !hasValidDestinationValues(latestDestinationValues)
        )
    );
}

function runHPDestinationEmptySearchErrorExperiment(abacusStore, systemOptions, formSettings, latestDestinationValues) {
    return runExperiment(abacusStore, 'HA_PTA_LANDING_DestinationlessError', {
        hasAllowableExperiment() {
            const {
                hasSubmitted,
                wasLastSubmittedSuccessfully
            } = formSettings;

            return (
                hasHPPageType(systemOptions) && (
                    !hasValidDestinationValues(latestDestinationValues) &&
                    hasSubmitted && !wasLastSubmittedSuccessfully
                )
            );
        }
    });
}

function runHPGuestPickerCTASearchExperiment(abacusStore, systemOptions, latestDestinationValues, latestDatesValues) {
    return runExperiment(abacusStore, 'HA_PTA_SEARCHBOX_launchSearchFromGuestPickerCTA', {
        hasAllowableExperiment() {
            return (
                hasHPPageType(systemOptions) && (
                    hasValidDestinationValues(latestDestinationValues) &&
                    hasValidDatesValues(latestDatesValues)
                )
            );
        }
    });
}

function runSLPDatePickerOpenedExperiment(abacusStore, systemOptions) {
    return runExperiment(abacusStore, 'HA_PTA_SEARCHFORM_SLP_Datepickeropened', {
        hasAllowableExperiment() {
            return hasSLPPageType(systemOptions);
        }
    });
}

/* istanbul ignore next */
function runAllExperiments() {
    const results = {};

    for (const experimentName of EXPERIMENT_NAMES) {
        results[experimentName] = runExperiment(experimentName);
    }

    return results;
}

export {
    EXPERIMENT_NAMES,
    getExperiment,
    hasAllowableFullExposureExperiment,
    hasRunnableAnyVariantExperiment,
    hasValidExperiment,
    hasAvailableExperiment,
    isHPDestinationEmptySearchErrorExperimentAvailable,
    runAllExperiments,
    runExperiment,
    runHPPrePopulateCookieExperiment,
    runHPDestinationEmptySearchErrorExperiment,
    runHPGuestPickerCTASearchExperiment,
    runSLPDatePickerOpenedExperiment
};
